export type SrmApiHandle =
  | `/external/access_tags`
  | `/external/cis/attributes`
  | `/external/graph`
  | `/external/graph/${string}`
  | `/external/tree/${string}`
  | `/type/tree`
  | `/type/list`
  | `/type/map`
  | `/type/${string}`
  | `/type`
  | `/type/${string}/child_ids`
  | `/type/${string}/parent_names`
  | `/type/parent_names/by_name`
  | `/type_count_cis`
  | `/type/${string}/attributes`
  | `/types/attributes`
  | `/type/${string}/ci_type_links`
  | `/types/ci_type_links`
  | `/type/${string}/links_graph`
  | `/ci_type_link/${string}/attributes`
  | `/type/${string}/composing`
  | `/type/${string}/link/${string}`
  | `/type/${string}/links`
  | `/type/check/${string}`
  | `/type/${string}/update_ci_names_with_template`
  | `/type/depends/${string}`
  | `/type/by_name`
  | `/type/by_name_with_children`
  | `/attribute`
  | `/attribute/map`
  | `/attributes/value_types`
  | `/attributes/value_schemas`
  | `/attributes/value_types_operators`
  | `/attributes/system_functions`
  | `/attribute/${string}`
  | `/link`
  | `/link/ids`
  | `/link/${string}`
  | `/ci/link/${string}`
  | `/fetchers`
  | `/fetcher/available`
  | `/fetcher/info/${string}`
  | `/fetcher/arguments-sample/${string}`
  | `/fetcher/rjsf_schema/${string}`
  | `/parsers`
  | `/parser/available`
  | `/parser/info/${string}`
  | `/parser/arguments-sample/${string}`
  | `/parser/rjsf_schema/${string}`
  | `/parser/render/${string}`
  | `/plugins`
  | `/plugins/installed`
  | `/plugins/${string}`
  | `/plugins/installed/${string}`
  | `/plugins/${string}/install`
  | `/plugins/install/runners`
  | `/plugins/upload`
  | `/type/${string}/parsers/link/${string}/dst/${string}`
  | `/type/${string}/parsers/link/${string}/dst/${string}/get_parent`
  | `/type/${string}/parsers/link`
  | `/type/${string}/parsers/link/${string}/dst/${string}/saved_settings`
  | `/type/${string}/fetchers/attribute/${string}`
  | `/type/${string}/fetchers/attribute/${string}/get_parent`
  | `/type/${string}/fetchers/attribute`
  | `/type/${string}/fetchers/attribute/${string}/saved_settings`
  | `/type/${string}/parsers/attribute/${string}`
  | `/type/${string}/parsers/attribute/${string}/get_parent`
  | `/type/${string}/parsers/attribute`
  | `/type/${string}/parsers/attribute/${string}/saved_settings`
  | `/type/${string}/modifiers/attribute/${string}`
  | `/type/${string}/modifiers/attribute/${string}/get_parent`
  | `/type/${string}/parsers/link_attribute/${string}`
  | `/type/${string}/link_attribute/attribute/${string}`
  | `/Dict/link_attribute/test`
  | `/parsers/link_attribute/find_test_cis`
  | `/type/${string}/link_attribute/attribute/${string}/saved_settings`
  | `/rule`
  | `/rule_brief`
  | `/rule/${string}`
  | `/rule/filter/all_ci_types`
  | `/rule/name/${string}`
  | `/rules/actions`
  | `/rules/accesses`
  | `/tql/rules`
  | `/tql/rules_brief`
  | `/tql/rule/${string}`
  | `/tql/rule`
  | `/tql/rule/${string}/tqls`
  | `/tql/rule/name/${string}`
  | `/tql/rules/actions`
  | `/tql/rules/accesses`
  | `/query`
  | `/query/${string}`
  | `/query_id/${string}/view`
  | `/query_name/${string}/view`
  | `/query_view`
  | `/query_view/${string}`
  | `/query/${string}/view/${string}`
  | `/identify_rules/${string}`
  | `/identify_rules/${string}/with_parent`
  | `/identify_rules/${string}/get_parent`
  | `/name_template/${string}`
  | `/name_template/${string}/with_parent`
  | `/name_template/${string}/get_parent`
  | `/delete_policy/${string}`
  | `/delete_policy/${string}/with_parent`
  | `/delete_policy/${string}/marked_cis`
  | `/delete_policy/${string}/all_cis/preview`
  | `/delete_policy/${string}/all_cis`
  | `/type/${string}/filters/link/${string}/dst/${string}`
  | `/type/${string}/filters/link/${string}/dst/${string}/get_parent`
  | `/type/${string}/filters/link`
  | `/type/${string}/fetchers/link/${string}/dst/${string}`
  | `/type/${string}/fetchers/link/${string}/dst/${string}/get_parent`
  | `/type/${string}/fetchers/link`
  | `/type/${string}/fetchers/link/${string}/dst/${string}/saved_settings`
  | `/enrichment/statistics/ci_type`
  | `/enrichment/statistics/ci_type/${string}/status/${string}`
  | `/enrichment/statistics/logs/${string}`
  | `/enrichment/statistics/reset`
  | `/enrichment_plan`
  | `/enrichment_plan/${string}`
  | `/import/enrichment_plans/json`
  | `/import/enrichment_plans/json_file`
  | `/export/enrichment_plans/json`
  | `/export/enrichment_plans/json_file`
  | `/send_event`
  | `/send_event_yaml`
  | `/export/cis/csv`
  | `/export/cis/csv_file`
  | `/export/cis/json_graph`
  | `/export/cis/json_graph_file`
  | `/import/ci_types/json`
  | `/import/ci_types/json_file`
  | `/export/ci_types/json`
  | `/export/ci_types/json_file`
  | `/export/attributes/json`
  | `/export/attributes/json_file`
  | `/dashboards/titles`
  | `/dashboards/default/${string}`
  | `/dashboard`
  | `/dashboard/${string}`
  | `/dashboard/${string}/clone`
  | `/widget/filled_template/widget_id`
  | `/widget/filled_template/templates`
  | `/widget/filled_template/widget_id/opensearch`
  | `/widget/filled_template/templates/opensearch`
  | `/tab/brief`
  | `/tab/basket`
  | `/tab/${string}`
  | `/tab`
  | `/tab/dashboard/${string}`
  | `/tab/widget`
  | `/tab/config`
  | `/tab/${string}/reset`
  | `/tab/${string}/dashboard`
  | `/tab/${string}/restore`
  | `/tab/${string}/widget/${string}`
  | `/dashboards/rules`
  | `/dashboards/rules_brief`
  | `/dashboards/rule/${string}`
  | `/dashboards/rule`
  | `/dashboards/rule/filter/all_dashboards`
  | `/dashboards/rule/orphan`
  | `/dashboards/rule/name/${string}`
  | `/dashboards/rules/actions`
  | `/dashboards/rules/accesses`
  | `/export/dashboards/json`
  | `/export/dashboards/json_file`
  | `/import/dashboards/json`
  | `/import/dashboards/json_file`
  | `/value_history`
  | `/value_history/${string}`
  | `/value_history/${string}/attribute/${string}`
  | `/value_history/${string}/attribute_name/${string}`
  | `/files`
  | `/files/${string}`
  | `/files/${string}/info`
  | `/settings`
  | `/settings/${string}`
  | `/schedules`
  | `/schedules/${string}`
  | `/tags`
  | `/tag`
  | `/tag/${string}`
  | `/templates`
  | `/template`
  | `/template/${string}`
  | `/accessories/filters`
  | `/accessories/blocks`
  | `/accessories/ci_type/${string}`
  | `/accessories/ci_types`
  | `/accessories/nodes`
  | `/version`
  | `/reset`
  | `/cell_towers/import`
  | `/cell_towers/count`
  | `/cell_towers`
  | `/graph/conditions/validate`
  | `/value-type-operators`
  | `/tree`
  | `/tree/ui_schema`
  | `/tree/query_id`
  | `/tree/${string}`
  | `/cached_tree/query_id`
  | `/tree/report/ui_schema`
  | `/tree/export`
  | `/tree/export/ui_schema`
  | `/opensearch/${string}/search`
  | `/opensearch/cursor/close`
  | `/opensearch/${string}/field_caps`
  | `/ci/${string}`
  | `/ci/${string}/map`
  | `/ci/with_actions/${string}`
  | `/cis/with_actions`
  | `/ci/${string}/name`
  | `/ci/${string}/fingerprint`
  | `/ci/${string}/connected`
  | `/cis`
  | `/cis/ci_type_name/${string}`
  | `/ci`
  | `/ci/map`
  | `/cis/delete`
  | `/cis/marked`
  | `/cis/attributes`
  | `/cis/attributes/graph`
  | `/cis/coordinates`
  | `/cis/map`
  | `/system/ci/${string}`
  | `/system/cis`
  | `/system/cis/map`
  | `/system/cis/with_ci_type_label`
  | `/system/cis/possible`
  | `/system/cis/weights`
  | `/system/cis/composing`
  | `/system/cis/ci_type_id/${string}`
  | `/system/cis/attributes`
  | `/system/cis/ci_name_or_type`
  | `/ci/enrichment/${string}`
  | `/ci/enrichment`
  | `/import/cis/csv/${string}/template`
  | `/import/cis/json/template`
  | `/import/cis/csv/${string}`
  | `/import/cis/json`
  | `/import/cis/bulk/csv/${string}`
  | `/import/cis/bulk/json`
  | `/import/cis/bulk/jobs`
  | `/import/cis/bulk/jobs/${string}`
  | `/import/cis/bulk/jobs/${string}/results`
  | `/import/cis/bulk/jobs/${string}/results/export`
  | `/import/cis/bulk/jobs/${string}/ci_types`
  | `/import/cis/bulk/jobs/${string}/issues`
  | `/import/cis/bulk/jobs/${string}/issues/export`
  | `/import/cis/bulk/jobs/${string}/cancel`
  | `/import/cit/validate`
  | `/import/cit/analyze`
  | `/import/cit/execute`
  | `/tql/convert`
  | `/tql/operators/search`
  | `/tql/graph`
  | `/tql/graph/${string}`
  | `/tql/graph/${string}/cached`
  | `/tql/grouped`
  | `/tql/grouped/cached`
  | `/tql/grouped/${string}/cached`
  | `/tql/hash`
  | `/tql/keep_alive`
  | `/ci/link_attributes/${string}`
  | `/ci/${string}/possible_ci_links/${string}`
  | `/ci/link`
  | `/ci/link_attributes/${string}/map`
  | `/import/enrichment_plans/validate`
  | `/import/enrichment_plans/analyze`
  | `/import/enrichment_plans/execute`
  | `/dashboards/rule/${string}/dashboards`
  | `/import/dashboards/analyze`
  | `/import/dashboards/validate`
  | `/import/dashboards/execute`
  | `/`
  | `/error/${string}`;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export interface SrmInstance extends AxiosInstance {
  get<T = any, R = AxiosResponse<T>, P extends string = SrmApiHandle>(
    url: P,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  delete<T = any, R = AxiosResponse<T>, P extends string = SrmApiHandle>(
    url: P,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  post<T = any, R = AxiosResponse<T>, P extends string = SrmApiHandle>(
    url: P,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  put<T = any, R = AxiosResponse<T>, P extends string = SrmApiHandle>(
    url: P,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
}

import axios from 'axios';
import { AXIOS_NO_CACHE_HEADERS } from '@/shared/api/no-cache-headers';
import i18n from '@/shared/config/i18n';

export const srmInstance = axios.create({
  baseURL: '/api/srm/v3',
  headers: AXIOS_NO_CACHE_HEADERS,
}) as SrmInstance;

i18n.on('languageChanged', (lng) => {
  srmInstance.defaults.headers.common['Accept-Language'] = lng;
});